import styled from "styled-components";
import {brand, fontFamilies} from "theme/tokens";

/**
 * Externalized styles for {@link ./ConfirmDialog} (ui#283, extracted from TransferListItem): the
 * destructive-confirmation body + the v3 ghost/danger action pair. The danger button is always
 * `brand.error` (mode-independent, never a palette red); everything else reads `theme.tokens`.
 */

/** Confirmation copy; `strong` emphasises the destructive noun / target name. */
export const ConfirmBody = styled.p`
	margin: 0;
	padding: 0 24px 8px;
	font-size: 14px;
	line-height: 1.55;
	color: ${({theme}) => theme.tokens.ink2};

	strong {
		color: ${({theme}) => theme.tokens.ink};
		font-weight: 700;
		overflow-wrap: anywhere;
	}
`;

export const ConfirmActions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 10px;
	padding: 16px 24px 20px;
`;

export const GhostButton = styled.button`
	border: none;
	background: transparent;
	color: ${({theme}) => theme.tokens.ink2};
	font: 600 13.5px ${fontFamilies.sans};
	padding: 9px 14px;
	border-radius: 10px;
	cursor: pointer;
	transition: 0.14s;

	&:hover {
		background: ${({theme}) => theme.tokens.field};
		color: ${({theme}) => theme.tokens.ink};
	}

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
	}
`;

/** Destructive confirm action — always `brand.error`, never a palette red (mode-independent). */
export const DangerButton = styled.button`
	border: none;
	background-color: ${brand.error};
	color: ${brand.white};
	font: 700 13.5px ${fontFamilies.sans};
	padding: 9px 16px;
	border-radius: 10px;
	cursor: pointer;
	transition: 0.14s;

	&:hover {
		filter: brightness(0.94);
	}

	&:focus-visible {
		outline: 2px solid ${brand.error};
		outline-offset: 2px;
	}
`;
